(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.show-hide-button').forEach(el => {
    el.addEventListener('click', (e) => {
      const isCollapsed = (el.dataset.collapsed === 'true');
      const mainContent = el.parentNode?.querySelector('.featured-collection-scroll-carousel-container');
      if (isCollapsed) {
        mainContent.classList.remove('hidden');
      } else {
        mainContent.classList.add('hidden');
      }
      el.dataset.collapsed = !isCollapsed;
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
